<template>
  <!-- 数据导入上传下载模版 -->
  <div class="upload-container">
    <el-dialog
      :close-on-click-modal="false" :title="uploadTitle"
                append-to-body
                :visible.sync="excelBox"
                width="555px">
      <avue-form :option="excelOption" v-model="excelForm" :upload-after="uploadAfter" :upload-before="uploadBefore">
        <template slot="excelTemplate">
          <el-button type="primary" @click="handleTemplate">
            点击下载<i class="el-icon-download el-icon--right"></i>
          </el-button>
        </template>
      </avue-form>
    </el-dialog>    
  </div>
</template>
<script>
import {getToken} from "@/util/auth";
export default {
  name: 'uploadModel',
  data() {
    return {
      excelBox: false,
      excelForm: {}  
    }
  },
  watch: {
    'excelForm.isCovered'() {
      if (this.excelForm.isCovered !== '') {
        const column = this.findObject(this.excelOption.column, "excelFile");
        // column.action = `${this.uploadUrl}?isCovered=${this.excelForm.isCovered}`;
        if(this.coveredParams){
          column.action = `${this.uploadUrl}?isCovered=${this.excelForm.isCovered}`
        }
        column.data.isCovered = this.excelForm.isCovered
      }
    }
  },
  props: {
    uploadTitle: {
      type: String,
      default: '基金数据导入'
    },
    uploadUrl: {
      type: String,
      default: '/api/blade-system/region/import-region'
    },
    openUrl: {
      type: String,
      default: '/api/blade-system/region/export-template'
    },
    covered: {
      type: Boolean,
      default: false
    },
    // 判断covered传参方式
    coveredParams: {
      type: Boolean,
      default: false
    },
    initTip: {
      type: String,
      default: ''
    }
  },
  computed: {
    excelOption () {
      return {
        submitBtn: false,
        emptyBtn: false,
        column: [
          {
            label: '模板上传',
            prop: 'excelFile',
            type: 'upload',
            drag: true,
            loadText: '模板上传中，请稍等',
            span: 24,
            propsHttp: {
              res: 'data'
            },
            tip: this.initTip !=='' ? this.initTip : '请上传 .xls,.xlsx 标准格式文件',
            action: this.uploadUrl,
            data: {}
          },
          {
            label: "数据覆盖",
            prop: "isCovered",
            type: "switch",
            align: "center",
            display: this.covered?true:false,
            width: 80,
            dicData: [
              {
                label: "否",
                value: 0
              },
              {
                label: "是",
                value: 1
              }
            ],
            value: 0,
            slot: true,
            rules: [
              {
                required: true,
                message: "请选择是否覆盖",
                trigger: "blur"
              }
            ]
          },
          {
            label: '模板下载',
            prop: 'excelTemplate',
            display: this.openUrl !== ''?true:false,
            formslot: true,
            span: 24,
          }
        ]
      }
    }
  },
  created() {},
  methods: {
    showModel() {
      this.excelForm.excelFile = []
      this.excelBox = true;
    },
    uploadBefore(file, done, loading, column) {
      if (this.excelForm.isCovered !== '') {
        if(this.coveredParams){
          column.action = `${this.uploadUrl}?isCovered=${this.excelForm.isCovered}`
        } else {
          column.data.isCovered = this.excelForm.isCovered
        }
      }
      done()
    },
    uploadAfter (res, done, loading, column) {
      // window.console.log(res, 'form-upload-after-res')
      // this.$message({
      //   type: "success",
      //   message: "上传成功",
      // })
      // 上传成功后触发刷新列表
      this.$emit('refreshData')
      this.excelBox = false
      done()
    },
    handleTemplate() {
      if(this.openUrl.indexOf('?')>=0){
        window.open(`${this.openUrl}&${this.website.tokenHeader}=${getToken()}&&hasTest=1`);
      }else{
        window.open(`${this.openUrl}?${this.website.tokenHeader}=${getToken()}&&hasTest=1`);
      }
    }
  }
}
</script>